import { render, staticRenderFns } from "./Animation20.vue?vue&type=template&id=1d22536b&scoped=true&"
import script from "./Animation20.vue?vue&type=script&lang=js&"
export * from "./Animation20.vue?vue&type=script&lang=js&"
import style0 from "./Animation20.vue?vue&type=style&index=0&id=1d22536b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22536b",
  null
  
)

export default component.exports